var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1617_85831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4999 5.57003V25.2C24.4999 26.7464 23.2463 28 21.6999 28H6.3C4.7536 28 3.5 26.7464 3.5 25.2V2.8C3.5 1.2536 4.7536 0 6.3 0H18.4357L24.4999 5.57003Z",
    fill: "url(#paint0_linear_1617_85831)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1617_85831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4997 5.57003H19.1355C18.7489 5.57003 18.4355 5.25663 18.4355 4.87003V0L24.4997 5.57003Z",
    fill: "#E0EAFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.63134 16.3762C7.09754 16.3762 7.50494 16.4686 7.85354 16.6534C8.20214 16.8382 8.47094 17.0986 8.65994 17.4346C8.85314 17.7664 8.94974 18.1507 8.94974 18.5875C8.94974 19.0201 8.85314 19.4044 8.65994 19.7404C8.47094 20.0764 8.20004 20.3368 7.84724 20.5216C7.49864 20.7064 7.09334 20.7988 6.63134 20.7988H4.97444V16.3762H6.63134ZM6.56204 19.8664C6.96944 19.8664 7.28654 19.7551 7.51334 19.5325C7.74014 19.3099 7.85354 18.9949 7.85354 18.5875C7.85354 18.1801 7.74014 17.863 7.51334 17.6362C7.28654 17.4094 6.96944 17.296 6.56204 17.296H6.05174V19.8664H6.56204ZM11.6434 20.8429C11.2276 20.8429 10.8454 20.7463 10.4968 20.5531C10.1524 20.3599 9.87728 20.0911 9.67148 19.7467C9.46988 19.3981 9.36908 19.0075 9.36908 18.5749C9.36908 18.1423 9.46988 17.7538 9.67148 17.4094C9.87728 17.065 10.1524 16.7962 10.4968 16.603C10.8454 16.4098 11.2276 16.3132 11.6434 16.3132C12.0592 16.3132 12.4393 16.4098 12.7837 16.603C13.1323 16.7962 13.4053 17.065 13.6027 17.4094C13.8043 17.7538 13.9051 18.1423 13.9051 18.5749C13.9051 19.0075 13.8043 19.3981 13.6027 19.7467C13.4011 20.0911 13.1281 20.3599 12.7837 20.5531C12.4393 20.7463 12.0592 20.8429 11.6434 20.8429ZM11.6434 19.8601C11.9962 19.8601 12.2776 19.7425 12.4876 19.5073C12.7018 19.2721 12.8089 18.9613 12.8089 18.5749C12.8089 18.1843 12.7018 17.8735 12.4876 17.6425C12.2776 17.4073 11.9962 17.2897 11.6434 17.2897C11.2864 17.2897 11.0008 17.4052 10.7866 17.6362C10.5766 17.8672 10.4716 18.1801 10.4716 18.5749C10.4716 18.9655 10.5766 19.2784 10.7866 19.5136C11.0008 19.7446 11.2864 19.8601 11.6434 19.8601ZM14.3217 18.5812C14.3217 18.1444 14.4162 17.7559 14.6052 17.4157C14.7942 17.0713 15.0567 16.8046 15.3927 16.6156C15.7329 16.4224 16.1172 16.3258 16.5456 16.3258C17.0706 16.3258 17.52 16.4644 17.8938 16.7416C18.2676 17.0188 18.5175 17.3968 18.6435 17.8756H17.4591C17.3709 17.6908 17.2449 17.5501 17.0811 17.4535C16.9215 17.3569 16.7388 17.3086 16.533 17.3086C16.2012 17.3086 15.9324 17.4241 15.7266 17.6551C15.5208 17.8861 15.4179 18.1948 15.4179 18.5812C15.4179 18.9676 15.5208 19.2763 15.7266 19.5073C15.9324 19.7383 16.2012 19.8538 16.533 19.8538C16.7388 19.8538 16.9215 19.8055 17.0811 19.7089C17.2449 19.6123 17.3709 19.4716 17.4591 19.2868H18.6435C18.5175 19.7656 18.2676 20.1436 17.8938 20.4208C17.52 20.6938 17.0706 20.8303 16.5456 20.8303C16.1172 20.8303 15.7329 20.7358 15.3927 20.5468C15.0567 20.3536 14.7942 20.0869 14.6052 19.7467C14.4162 19.4065 14.3217 19.018 14.3217 18.5812ZM22.0122 20.7988L21.1113 19.4443L20.3175 20.7988H19.0953L20.5128 18.5497L19.0638 16.3762H20.3175L21.2058 17.7118L21.987 16.3762H23.2092L21.8043 18.6064L23.2659 20.7988H22.0122Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1617_85831",
    x: 16.3355,
    y: -0.7,
    width: 8.86397,
    height: 8.37031,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.7,
    dy: 0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1617_85831"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1617_85831",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1617_85831",
    x1: 35.35,
    y1: -16.45,
    x2: -8.05,
    y2: 40.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#A4BCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90788,
    stopColor: "#444CE7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1617_85831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.ac8a78d28a402b7e9695bb6b85fd689b.svg";
export { ForwardRef as ReactComponent };